import React from 'react';
import styled from 'styled-components';

const Image = styled.img`
    width: 100%;

    &:hover {
        cursor: pointer;
    }
`;

const SingpassButtonImage = props => <div><Image {...props} /></div>

export default SingpassButtonImage;
